import { Component } from '@angular/core';
import { routerTransition } from "./route.animations";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
}



// WEBPACK FOOTER //
// C:/pgutev/work/WEBCAM/src/app/app.component.ts